import type { PressRefusal } from '../AiOverviewPanel/pressRefusal';

export interface BuildFlowResolvedDetail {
  ok?: boolean;
  clickId?: string | null;
  reason?: string;
  /** Why nothing started and the one fix, for the button that was pressed to show in place. */
  refusal?: PressRefusal;
  /** Set by the button that shows the refusal in place; otherwise the build flow toasts it. */
  refusalShown?: boolean;
}

/** Only a scoped success can finalize a persisted build-button decision. */
export const isSuccessfulBuildResolution = (
  detail: BuildFlowResolvedDetail,
  expectedClickId: string | null,
): boolean => Boolean(
  detail.ok === true
  && detail.clickId
  && detail.clickId === expectedClickId,
);
